import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { RowView } from "../../../../Component/style/common_style";

interface depositData extends modalProps {
  data: {
    date: string;
    name: string;
    price: number;
    note: string;
  };
  type: string;
}

const MatchingApplyModal = ({
  visible,
  handleModal,
  data,
  type,
}: depositData) => {
  const closeModal = () => {
    handleModal();
  };
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  return (
    <Container
      style={visible ? {} : { display: "none" }}
      onClick={stopPropagation}
    >
      <ModalBox onClick={stopPropagation}>
        <ContentDiv>
          {type === "삭제" && "삭제하시겠습니까?"}

          {type === "매칭" && "해당 정보와 매칭하시겠습니까?"}
        </ContentDiv>
        <BtnDiv>
          <CancelBtn onClick={closeModal}>아니오</CancelBtn>
          <ApplyBtn>
            {" "}
            {type === "삭제" && "삭제하기"}
            {type === "매칭" && "매칭하기"}
          </ApplyBtn>
        </BtnDiv>
      </ModalBox>
    </Container>
  );
};
export default MatchingApplyModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 22rem;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 2rem 1rem 1rem 1rem;
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const ContentDiv = styled.div`
  padding: 60px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
  flex-direction: column;
  text-align: center;
  color: black;
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.div`
  border-radius: 8px;
  padding: 18px 30px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;

const CancelBtn = styled(Btn)`
  margin-right: 5px;
  background-color: #e4e4e4;
  color: #8e8e8e;
`;

const ApplyBtn = styled(Btn)`
  margin-left: 5px;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  color: white;
`;
